<template>
  <!-- .company-info-auth .cia -->
  <div class="cia">
    <!-- <div class="cia-form"> -->
    <div class="cia-form" v-if="auth!== 0 && auth !== 1">
      <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        label-position="right"
        :label-width="150"
        @submit.native.prevent
      >
        <FormItem label="营业执照：">
          <div
            class="my-upload-list"
            v-for="(item, index) in uploadList"
            :key="'upload' + index"
            style="width: 100px;height: 100px;line-height:100px;margin-bottom:0;"
          >
            <template v-if="item.status === 'finished'">
              <img :src="item.url" style="width: 100px;height: 100px;" />
              <div class="my-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemoveByArr(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
              </Spin>
            </template>
          </div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :max-size="2048"
            :headers="formHeaders"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            type="drag"
            :action="uploadUrl"
            multiple
            style="display: inline-block;width:100px;"
            v-show="uploadList && uploadList.length < 1"
          >
            <div style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);">
              <div style="font-size:25px;">
                +
                <p style="font-size:14px;">上传高清图片</p>
              </div>
            </div>
            <!-- 蒙版 -->
            <div
              style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"
              @click.stop="selectType"
            ></div>
          </Upload>
          <pre
            style="font-size: 12px;margin: 0;line-height: initial;color: rgb(128, 128, 128);margin-top:10px;"
          >
上传营业执照图片；
清晰的图片可以让您更快通过审核；
推荐上传扫面文件，拍照请尽量降低反光；
请确保营业执照图片所有信息清晰可见，内容真实有效，无任何修改；
文件大小不超过8M,支持.jgp .jpeg .bpm .png .pdf格式。
</pre>
        </FormItem>
        <FormItem label="组织机构代码：" prop="code">
          <Input type="text" v-model="formInline.code" placeholder="请输入组织机构代码" />
        </FormItem>
        <FormItem label="企业名称：" prop="name">
          <Input type="text" v-model="formInline.name" placeholder="请输入企业名称" />
        </FormItem>
        <FormItem label="经营年限：" prop="lifeLimit">
          <Row>
            <Col span="21">
              <DatePicker
                type="datetimerange"
                format="yyyy-MM-dd"
                placeholder="请选择日期"
                style="width: 100%"
                v-model="formInline.actTime"
                @on-change="change2"
                :disabled="formInline.long"
              ></DatePicker>
            </Col>
            <Col span="3">
              <div class="f-tar">
                <Checkbox v-model="formInline.long">
                  <span style="padding: 0 3px"></span>长期
                </Checkbox>
              </div>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="所在省市：" style="margin-bottom: 10px;">
          <Row type="flex" justify="space-between">
            <Col span="7">
              <FormItem prop="province">
                <Select
                  v-model="formInline.province"
                  placeholder="请选择省份"
                  @on-change="changeProvince"
                >
                  <Option
                    v-for="(item, index) in provinceArr"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem prop="city">
                <Select v-model="formInline.city" placeholder="请选择城市" @on-change="changeCity">
                  <Option
                    v-for="(item, index) in citiesArr"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem prop="county">
                <Select v-model="formInline.county" placeholder="请选择区县" @on-change="changeCity">
                  <Option
                    v-for="(item, index) in countyArr"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="详细地址：" prop="address">
          <Input type="text" v-model="formInline.address" placeholder="请输入详细地址" />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            size="large"
            @click="handleSubmit('formInline')"
            :loading="loading"
            style="width: 154px;"
          >提交</Button>
        </FormItem>
      </Form>
    </div>
    <div class="cia-auth" v-if="auth === 0">
      <div class="cia-auth-box">
        <div class="info">
          <p style="color: inherit;">已收到您的认证申请，请耐心等待...</p>
        </div>
      </div>
    </div>
    <div class="cia-auth" v-if="auth === 1">
      <div class="cia-auth-box">
        <div class="logo">
          <img src="@/assets/img/company-logo-1.png" />
        </div>
        <div class="info">
          <p>恭喜！您已完成云展台企业实名认证！</p>
          <span>企业名称：{{authData.companyName}}</span>
          <span>证件号码：{{authData.code}}</span>
        </div>
      </div>
    </div>

    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />
    <!-- 图片查看 -->
    <iModal title="图片查看" cancel-text v-model="visible">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>
  </div>
</template>

<script>
let moment = require("moment");
import { provinces } from "@/other/provinces";
import { validator } from "@/other/validator";
import { mapGetters, mapMutations, mapActions } from "vuex";
import imgUpload from "@components/imgUpload/imgUpload.vue";

export default {
  name: "company-info-auth",
  data() {
    const that = this;
    const actTimeReg = (rule, value, callback) => {
      if (value && value[0]) {
        callback();
      } else {
        callback("请输入正确的经营年限");
      }
    };
    const limitTimeReg = (rule, value, callback) => {
      if (that.actTime && that.actTime[0]) {
        callback();
      } else {
        callback("请输入正确的经营年限");
      }
    };
    return {
      auth: false,
      loading: false,
      provinceArr: [],
      citiesArr: [],
      countyArr: [],

      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      formInline: {
        // form双向绑定
        code: "",
        name: "",
        shortName: "",
        address: "",
        introduction: "",
        province: "",
        actTime: [],
        city: "",
        county: "",
        long: true
      },
      ruleInline: {
        // 效验规则
        name: [
          { required: true, message: "公司全称不能为空", trigger: "blur" },
          {
            type: "string",
            min: 3,
            message: "公司全称不能小于4位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 50,
            message: "公司全称不能大于50位",
            trigger: "blur"
          }
        ],
        actTime: [{ required: true, validator: actTimeReg, trigger: "blur" }],
        lifeLimit: [
          { required: true, validator: limitTimeReg, trigger: "blur" }
        ],
        address: [
          { required: true, message: "公司地址不能为空", trigger: "blur" }
        ],
        code: [
          { required: true, message: "组织机构代码不能为空", trigger: "blur" }
        ],
        province: [
          {
            required: true,
            message: "请选择所在的省份",
            trigger: "change"
          }
        ],
        city: [
          { required: true, message: "请选择所在的城市", trigger: "change" }
        ],
        county: [
          { required: true, message: "请选择所在的区县", trigger: "change" }
        ],
        introduction: [
          { required: true, message: "公司简介不能为空", trigger: "blur" },
          {
            type: "string",
            max: 2000,
            message: "公司简介不能超过2000字",
            trigger: "blur"
          }
        ]
      },
      visible: false,
      defaultList: [],

      uploadList: [],

      coverImg: "",
      uploadVideoFlag: false,
      authData: null
    };
  },
  components: {
    imgUpload
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    })
  },
  created() {
    this.provinceArr = provinces.data;
    this.init();
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      getCompany: "loginModule/getCompany",
      editCompany: "companyModule/editCompany",

      getCompLicense: "loginModule/getCompLicense",
      addCompLicense: "loginModule/addCompLicense",
      editCompLicense: "loginModule/editCompLicense"
    }),
    change2(e) {
      this.actTime = e;
    },
    async init() {
      this.authData = await this.getCompLicense(this.company.id); 
      console.log("this.authData: ", this.authData);
      if (!this.authData) return;
      this.formInline.name = this.authData.companyName;
      this.formInline.code = this.authData.code;
      this.formInline.address = this.authData.address;
      this.formInline.long = this.authData.isLongTerm;
      this.auth = this.authData.auditType;
      this.authData.lifeLimit = this.authData.lifeLimit
        ? JSON.parse(this.authData.lifeLimit)
        : ["", ""];
      this.formInline.actTime = [
        this.authData.lifeLimit.StartDate,
        this.authData.lifeLimit.EndDate
      ];

      this.defaultList = [
        {
          name: this.authData.companyName,
          url: this.authData.license,
          status: "finished",
          percentage: 100
        }
      ];
      if (this.authData.country) {
        this.formInline.country = this.authData.country || "中国";
      }
      if (this.authData.province) {
        this.changeProvince(this.authData.province);
        this.formInline.province = this.authData.province || "";
      }
      if (this.authData.city) {
        this.changeCity(this.authData.city);
        this.formInline.city = this.authData.city || "";
      }
      if (this.authData.county) {
        this.formInline.county = this.authData.county || "";
      }
      this.formInline.long = this.authData.isLongTerm;
      this.uploadList = this.defaultList;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "Incorrect file format",
        desc: "Upload image in jpg/png format"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "File size exceeds configured limit",
        desc: "Upload image size less than 2M"
      });
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload ${limitNum} image only`
        });
      }
      return check;
    },
    // 选择图片上传方式
    selectType() {
      this.uploadList = [];
      this.defaultList = [];
      this.$refs.upload.fileList = [];
      this.uploadChooseShowed = true;
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    },

    changeProvince(val) {
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (val == this.provinceArr[i].value) {
          this.formInline.city = "";
          this.formInline.county = "";
          this.citiesArr = this.provinceArr[i].children;
          this.countyArr = [];
        }
      }
    },
    changeCity(val) {
      for (var i = 0; i < this.citiesArr.length; i++) {
        if (val == this.citiesArr[i].value) {
          this.formInline.county = "";
          this.countyArr = this.citiesArr[i].children;
        }
      }
    },

    async handleSubmit(name) {
      this.loading = true;
      setTimeout(c => {
        this.loading = false;
      }, 5000);
      if (this.authData) {
        this.editSubmit();
      } else {
        this.addSubmit();
      }
    },
    async editSubmit() {
      let form = this.formInline;
      let valid = await this.validForm("formInline");
      if (!valid) {
        this.loading = false;
        return;
      }
      let logo = "";
      // 修改提交
      if (this.uploadList && this.uploadList.length) {
        logo = this.uploadList[0].url;
      } else {
        this.$Message.error("请上传营业执照");
        return;
      }
      let StartDate = "";
      let EndDate = "";

      if (this.actTime && this.actTime[0]) {
        StartDate = moment(this.actTime[0]).format("YYYY-MM-DD");
      }
      if (this.actTime && this.actTime[1]) {
        EndDate = moment(this.actTime[1]).format("YYYY-MM-DD");
      }
      let dateArr = { StartDate: StartDate, EndDate: EndDate };
      if (form.long) {
        dateArr = { StartDate: "", EndDate: "" };
      } 

      const req = {
        Id: this.authData.id,
        SetValues: {
          CompId: this.company.id,
          License: logo,
          Code: form.code,
          CompanyName: form.name,
          LifeLimit: dateArr,
          County: form.county,
          City: form.city,
          Province: form.province,
          Address: form.address,
          AuditType: this.authData.AuditType,
          IsLongTerm: form.long,
          // AuditType说明: "-1：不通过，0：待审核，1：通过",
          AuditRemark: ""
        }
      };
      const bool = await this.editCompLicense(req);
      if (!bool) {
        this.$Message.error("提交未通过!");
        return false;
      }
      if (bool.errors && bool.errors[0]) {
        this.$Message.error(bool.errors[0].description);
        return;
      }
      this.$Message.success("提交成功!");
      this.loading = false;
    },
    async addSubmit() {
      this.loading = true;
      setTimeout(c => {
        this.loading = false;
      }, 5000);
      let form = this.formInline;
      let valid = await this.validForm("formInline");
      if (!valid) {
        this.loading = false;
        return;
      }
      let logo = "";
      // 添加提交
      if (this.uploadList && this.uploadList.length) {
        logo = this.uploadList[0].url;
      } else {
        this.$Message.error("请上传营业执照");
        return;
      }
      let StartDate = "";
      let EndDate = "";

      if (this.actTime && this.actTime[0]) {
        StartDate = moment(this.actTime[0]).format("YYYY-MM-DD");
      }
      if (this.actTime && this.actTime[1]) {
        EndDate = moment(this.actTime[1]).format("YYYY-MM-DD");
      }
      let dateArr = { StartDate: StartDate, EndDate: EndDate };
      if (form.long) {
        dateArr = { StartDate: "", EndDate: "" };
      }
      const req = {
        CompId: this.company.id,
        License: logo,
        Code: form.code,
        CompanyName: form.name,
        LifeLimit: dateArr,
        County: form.county,
        City: form.city,
        Province: form.province,
        Address: form.address,
        AuditType: "0",
        IsLongTerm: form.long,
        // AuditType说明: "-1：不通过，0：待审核，1：通过",
        AuditRemark: ""
      };
      const bool = await this.addCompLicense(req);
      if (!bool) {
        this.$Message.error("提交未通过!");
        return false;
      }
      if (bool.errors && bool.errors[0]) {
        this.$Message.error(bool.errors[0].description);
        return;
      }
      this.loading = false;
      this.$Message.success("提交成功!");
    }
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
  }
};
</script>

<style scoped lang="scss">
.cia {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  padding-bottom: 50px;
  min-height: 700px;
  background: #fff;
  &-form {
    width: 800px;
  }
  &-auth {
    min-height: 420px;
    &-box {
      display: flex;
      height: 110px;
      justify-content: center;
      align-items: center;
      padding-top: 155px;
      .info {
        margin-left: 50px;
        position: relative;
        top: -5px;
        p {
          font-size: 32px;
          color: #1890ff;
          font-weight: bold;
        }
        span {
          font-size: 20px;
          color: #1890ff;
          display: block;
        }
      }
    }
  }
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
</style>
